import React from 'react'
import { Typography, Icon, Row, Col, Collapse } from 'antd';
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
import { Queries } from '../../../graphql'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { convertToHTMl } from '../../../utils/markDown'

const { Text, Title } = Typography

const { Panel } = Collapse;

class ContactHR extends React.Component {

    state = {
        detailDocumen: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false
    }

    fetchListDocumen = async () => {
        const { client, location } = this.props
        const { selectMonth, selectYear } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchListDocumen,
            variables: {
                docGroupId: location.state.fetchKey
            }
        })
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            detailDocumen: data.fetchListDocument,
        })
    }

    async componentDidMount() {
        await this.fetchListDocumen()
    }


    render() {
        const { match, location } = this.props
        const { detailDocumen } = this.state

        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-abouts-hr">
                    <Row>
                        <Col>
                            <Collapse accordion>
                                {
                                    detailDocumen &&
                                    <>
                                        {
                                            detailDocumen.length !== 0 &&
                                            detailDocumen.map((value, keys) =>
                                                <Panel header={value.docTitle} key={keys}>
                                                    {/* { value.docDescription ? <div dangerouslySetInnerHTML={{ __html: convertToHTMl(value.docDescription) }}/> : '' } */}
                                                    {/* <div dangerouslySetInnerHTML={{ __html:value.docDescription }}></div> */}
                                                    <pre>
                                                        { value.docDescription }
                                                    </pre>
                                                </Panel>
                                            )
                                            ||
                                            <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                                <Text className="color-gray" >ไม่พบข้อมูล</Text>
                                            </div>
                                        }
                                    </>
                                    ||
                                    <div style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                        <Text className="color-gray" >ไม่พบข้อมูล</Text>
                                    </div>
                                }
                            </Collapse>
                        </Col>
                    </Row>
                </div>
            </Container>
        )
    }
}

ContactHR.propTypes = {
    //
}

export default withApollo(ContactHR)